<template>
  <WModal
    v-model="isOpen"
    head-line="Slots"
    :action-type="Actions.CancelConfirm"
    confirm-text="Set slots"
    :confirm-disabled="!isChanged"
    :allow-icon="false"
    max-width="480px"
    :section-tag="sectionTag"
    @confirm="handleConfirm"
    @cancel="isOpen = false"
  >
    <template #content>
      <div class="fleet-runner-slots">
        <p class="fleet-runner-slots__text">{{ text.message }}</p>
        <p class="fleet-runner-slots__fact" :data-testid="`${sectionTag}-setting`">{{ facts.setting }}</p>
        <p class="fleet-runner-slots__fact" :data-testid="`${sectionTag}-now`">{{ facts.now }}</p>
        <WDropdown
          v-model="chosen"
          label="Runs at once"
          :items="FLEET_RUNNER_SLOTS_OPTIONS"
          item-title="title"
          item-value="value"
          :section-tag="`${sectionTag}-value`"
        />
      </div>
    </template>
  </WModal>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import { FLEET_RUNNER_SLOTS_OPTIONS, runnerChoiceText, runnerSlotsFacts, runnerSlotsSetting } from '@/services/claude-fleet'
import type { FleetRunner, FleetRunnerSlotsValue } from '@/services/claude-fleet'
import { Actions } from '@/constants/actions'

import WModal from '@wasabi/content-displays/WModal.vue'
import WDropdown from '@wasabi/inputs/WDropdown.vue'

const props = defineProps<{ runner: FleetRunner; ownerName: string; sectionTag: string }>()

const emit = defineEmits<{ confirm: [value: FleetRunnerSlotsValue] }>()

const isOpen = defineModel<boolean>({ required: true })

const current = computed(() => runnerSlotsSetting(props.runner))
const chosen = ref<FleetRunnerSlotsValue | null>(current.value)

const facts = computed(() => runnerSlotsFacts(props.runner))
const text = computed(() => runnerChoiceText('slots', props.ownerName))
const isChanged = computed(() => chosen.value !== null && chosen.value !== current.value)

watch(isOpen, opened => {
  if (opened) chosen.value = current.value
})

function handleConfirm() {
  isOpen.value = false
  if (chosen.value !== null) emit('confirm', chosen.value)
}
</script>

<style scoped>
.fleet-runner-slots {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.fleet-runner-slots__text,
.fleet-runner-slots__fact {
  margin: 0;
  overflow-wrap: anywhere;
}

.fleet-runner-slots__fact {
  font-size: 12px;
  color: var(--color-content-text-muted, #767676);
}
</style>
